import ArtifactGroupType from "../base/ArtifactGroupType";


const KeyOfLife = {
  id: '110',
  name: 'Key Of Life',
  groupIcon: 'TreasuresOfTheNile',
  type: ArtifactGroupType.TREASURES_OF_THE_NILE,
  icon: 'KeyOfLife',
  power: 50,
  gameId: 'KeyOfLife'
};

export default KeyOfLife;
